import React from 'react';
import './App.css';
import XiamenTripPlanner from './XiamenTripPlanner';

function App() {
  return (
    <div className="App">
      <XiamenTripPlanner />
    </div>
  );
}

export default App;